<div [formGroup]="form" class="row form-wrapper">
  <div class="col-12">
    <app-select-form-field
      formControlName="author"
      [label]="'label.news_author' | translate"
      [placeholder]="'placeholders.news_author'"
      [multipleSelect]="false"
      [items]="authors"
    ></app-select-form-field>
  </div>

<!-- NOT NEEDED FOR NOW  -->
  <!-- <div class="col-12">
    <app-select-form-field
      formControlName="newsType"
      [label]="'label.news_type' | translate"
      [placeholder]="'placeholder.news_type' | translate"
      [multipleSelect]="false"
      [items]="newsTypes"
    ></app-select-form-field>
  </div>
</div> -->
